import { TabContext } from "@mui/lab";
import { useMountEffect } from "@react-hookz/web";
import React from "react";
import { useQueryLoader } from "react-relay";
import { useSdkContext } from "~/components/contexts";
import { DashboardBadge } from "~/components/dashboard-widget/badge";
import { useIsFirstTimeVisitNotificationPanel } from "~/components/dashboard-widget/badge/hooks";
import { useDashboardMessages } from "./hooks";
import NotificationIcon from "./icon-notification.svg";
import ReadingHistoryIcon from "./icon-reading-history.svg";
import { NotificationPanel } from "./notification-panel";
import { query } from "./notification-panel/notification-list";
import { ReadingHistoryPanel } from "./reading-history-panel";
import { useReadingHistoryWithArticle } from "./reading-history-panel/hooks";
import { Container, Content, Footer, Greeting, Header, HeaderContent, Link, Message, StyledTab, StyledTabList, StyledTabPanel, UserName } from "./styles";
export const DashboardDisplay = ({
  beforeHeaderSlot,
  className,
  messageRenders
}) => {
  var _user$username;
  const {
    config,
    handleOpenLoginDialog,
    handleRoutePush,
    handleTrackGA,
    handleTrackGA4,
    user
  } = useSdkContext();
  const [currentTab, setCurrentTab] = React.useState("notification");
  const username = user !== null && user !== void 0 && user.firstname && user !== null && user !== void 0 && user.lastname ? `${user.firstname} ${user.lastname}` : (_user$username = user === null || user === void 0 ? void 0 : user.username) !== null && _user$username !== void 0 ? _user$username : "Guest";
  const renderAccountLink = position => {
    if (!user) {
      return /*#__PURE__*/React.createElement(Link, {
        onClick: () => {
          handleTrackGA({
            action: "Login/Click",
            category: "Login",
            label: ""
          });
          handleOpenLoginDialog({
            destination: window.location.href,
            ga4CustomParameter: {
              trigger_point: "header"
            }
          });
        }
      }, "Sign In / Register");
    }
    return /*#__PURE__*/React.createElement(Link, {
      onClick: () => {
        handleTrackGA({
          action: position === "bottom" ? "My Account/Overlay/My Account (Bottom)" : "My Account/Overlay/My Account",
          category: "My Account",
          label: ""
        });
        const url = new URL(`${config.accounts.host}/settings`);
        url.searchParams.set("destination", window.location.href);
        void handleRoutePush(url.toString());
      },
      "data-qa": "render-account-link"
    }, "My Account");
  };
  const {
    message
  } = useDashboardMessages(messageRenders);
  const [notificationListQuery, loadNotificationListQuery] = useQueryLoader(query);
  useMountEffect(() => {
    loadNotificationListQuery({});
  });
  const {
    state: readingHistoryState
  } = useReadingHistoryWithArticle();
  const {
    setIsFirstTime
  } = useIsFirstTimeVisitNotificationPanel();
  const handleReadHistoryClick = () => {
    handleTrackGA4({
      action: "click",
      category: "readinghistory",
      customized_parameters: {
        action_type: "open",
        article_id: ""
      },
      subcategory: ""
    });
  };
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    "data-qa": "dashboard-display"
  }, /*#__PURE__*/React.createElement(Header, null, beforeHeaderSlot, /*#__PURE__*/React.createElement(HeaderContent, null, /*#__PURE__*/React.createElement(Greeting, null, "Hi, ", /*#__PURE__*/React.createElement(UserName, null, username)), renderAccountLink("top"), /*#__PURE__*/React.createElement(Message, null, message))), /*#__PURE__*/React.createElement(TabContext, {
    value: currentTab
  }, /*#__PURE__*/React.createElement(StyledTabList, {
    variant: "fullWidth",
    onChange: (_, value) => {
      setCurrentTab(value);
    }
  }, /*#__PURE__*/React.createElement(StyledTab, {
    "aria-label": "Notification",
    icon: /*#__PURE__*/React.createElement(DashboardBadge, null, /*#__PURE__*/React.createElement(NotificationIcon, {
      color: "#001246"
    })),
    value: "notification",
    disableRipple: true,
    onClick: () => setIsFirstTime(false)
  }), /*#__PURE__*/React.createElement(StyledTab, {
    "aria-label": "Reading History",
    icon: /*#__PURE__*/React.createElement(ReadingHistoryIcon, {
      color: "#001246"
    }),
    value: "reading-history",
    disableRipple: true,
    onClick: handleReadHistoryClick
  })), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(StyledTabPanel, {
    value: "notification"
  }, /*#__PURE__*/React.createElement(NotificationPanel, {
    notificationListQuery: notificationListQuery
  })), /*#__PURE__*/React.createElement(StyledTabPanel, {
    value: "reading-history"
  }, /*#__PURE__*/React.createElement(ReadingHistoryPanel, {
    state: readingHistoryState
  })))), /*#__PURE__*/React.createElement(Footer, null, renderAccountLink("bottom")));
};
DashboardDisplay.displayName = "DashboardDisplay";